/**
 * An enumeration of all configured routes.
 */
export const ROUTES = {
    CODE: '/',
    HELP: '/help',
    HOME: '/tv',
    LOADING: '/loading',
    MEETING: '/meeting',
    OLD_HOME: '/spot',
    OUTLOOK_OAUTH: '/oauth',
    REMOTE_CONTROL: '/remote-control',
    SETUP: '/setup',
    SHARE: '/share',
    SHARE_HELP: '/share-help',
    UNSUPPORTED_BROWSER: '/unsupported-browser'
};
